import React, { Component } from "react";
import { withPixiApp } from "@inlet/react-pixi";
import { connect } from "react-redux";
import { GJIStore } from "../gamestore/IStore";
import { Dispatch } from "redux";
import { actions as gameActions } from "../gamereducer/actionReducer";
import { actions as baseGameActions, actions as baseGameAction } from "../core/reducers/baseGameReducer";
import { actions as reelgridAction } from '../core/reducers/reelgridStateReducer';
import { actions as applicationStateActions } from "../core/reducers/applicationStateReducer"
import { actions as winActions } from '../core/reducers/winPresentationReducer';
import { actions as basegameActions } from "../core/reducers/baseGameReducer";
import { actions as freegameAction } from "../core/reducers/freeGameReducer";
import { actions as betPanelAction } from "../core/reducers/betPanelReducer";
import { actions as paytableAction } from "../gamereducer/paytableGameReducer";
import { actions as introductionActions } from "../gamereducer/introductionPageReducer";
import { actions as asyncActions } from '../core/reducers/asyncInitAction'
import { actions as asyncServerActions } from "../core/reducers/asyncServerResponseReducer";
import { actions as behaviourAction } from '../gamereducer/behaviourReducer';
import { actions as gameLevelResponseActions } from "../gamereducer/asyncGameLevelServerResponseReducer";
import { isMobile } from "react-device-detect";
import { actions as multiplierActions } from "../gamereducer/multiplierReducer";
import { TIMER } from "../core/utills";
import { actions as buttonActions } from "../core/reducers/buttonPanelReducer";
import { configGame, constant } from "../data/config/index";
import { actions as landingSymbolAction } from "../core/reducers/landingsymbolreducer";
import { actions as winpresentationAction } from "../core/reducers/winPresentationReducer";
import { actions as flowManagerAction } from "../core/reducers/flowManagerReducer";
import { actions as lockedReelActions } from "../gamereducer/lockedReelReducer";
import { actions as retriggerActions } from "../gamereducer/retriggerReducer";
import { actions as randomWildAcitons } from "../gamereducer/randomWildReducer";
import { actions as skullActions } from '../gamereducer/skullReducer';
import { actions as giantWildActions } from '../gamereducer/giantWildReducer';
import { actions as gameRandomWildActions } from '../gamereducer/gameRandomWildReducer';
import { actions as gridsActions } from '../core/reducers/gridStateReducer';
import { actions as baseGameReconstructionActions } from '../gamereducer/baseGameReconstructionReducer';
import { actions as winDropActions } from '../gamereducer/winDropReducer';
import { actions as promotionalFreeRoundActions } from '../gamereducer/promotionalFreeRoundReducer';
import { indexOf } from "lodash";




interface IProps {
    [x: string]: any;
}

interface IStateToProps {

    [x: string]: any;

}

interface IDispatchToProps {
    [x: string]: any;

}


interface IState {
    [x: string]: any;

}

class ServerComm extends Component<IProps, IState> {
    protected symbolMappingList: any = [];
    protected symbolsArrayLength: number = 9;
    protected scatterCounter: number = 0;
    protected scatterCounterForSpin: number = 0;
    protected counterScatterSymbolForSpin: number = 0;
    protected symbolsNoOfSizes: number = 6;
    protected lastScatterSymbolID: number = 30;
    protected storePreviousFreeGameCount: number = 0;
    protected filteredreelData: any;
    protected filteredreelDataSpinBeforeBlast: any;
    protected filteredreelDataSpinAfterBlast: any;
    protected blastPositionArray: any = [];
    protected winningPosition: any = [];
    protected symbolForAnticipationArray: any = [];
    protected storeReelsData: any;
    protected setReelsTrue: boolean = false;
    protected anticipationSymbolList: any = constant.reelgridConfig.ANTICIPATION_SYMBOL_LIST;
    protected anticipationTriggeringMinCount: any = constant.reelgridConfig.ANTICIPATION_TRIGGERING_SYMBOL_MIN_COUNT;
    protected anticipationTriggeringMaxCount: any = constant.reelgridConfig.ANTICIPATION_TRIGGERING_SYMBOL_MAX_COUNT;
    protected lineWins: any;
    protected winAmountDisplay: any;
    protected totalWinAmountFG: any;
    private gameBalance: any;
    private freeSpinCounter: number = 0;
    private initResult: any;
    private spinResultData: any;
    private spinResultReceived: boolean;

    protected counterScatterCount = 0;
    protected timeForDropDone = false;


    constructor(props: IProps) {
        super(props);
        this.initResult = {};
        this.spinResultData = {};
        this.timeForDropDone = false;
        this.spinResultReceived = false;
        this.symbolMappingList = [
            { id: 0, name: "0" },
            { id: 1, name: "1" },
            { id: 2, name: "2" },
            { id: 3, name: "3" },
            { id: 4, name: "4" },
            { id: 5, name: "5" },

            { id: 6, name: "6" },
            { id: 7, name: "7" },
            { id: 8, name: "8" },
            { id: 9, name: "9" },
            { id: 10, name: "10" },
            { id: 11, name: "11" },


        ]

    }
    setSpinDataForDrop() {
        this.timeForDropDone = false;
        this.spinResultReceived = false;
        // this.props.setImmediateResponse(false);

        this.winAmountDisplay = this.winAmountDisplay + this.spinResultData.response.results.win.total / 10 * this.spinResultData.response.bet.stake;
        this.totalWinAmountFG = this.totalWinAmountFG + this.spinResultData.response.results.win.total / 10 * this.spinResultData.response.bet.stake;

        if (this.spinResultData.response.state.hasCapped) {
            this.winAmountDisplay = this.spinResultData.response.state.cap / 10 * this.spinResultData.response.bet.stake;
            this.totalWinAmountFG = this.spinResultData.response.state.cap / 10 * this.spinResultData.response.bet.stake;
            this.spinResultData.response.state.wonAdditionalSpins = 0;
            this.spinResultData.response.results.win.total = 0;
            this.spinResultData.response.state.freespinsRemaining = this.spinResultData.response.state.totalFSAwarded;
            this.props.setWinSymbolCoOrdinate([]);
            this.props.blastPositionSet([]);
            this.props.setGiantWildPositions([])


        }

        this.parseCascadeData(this.spinResultData);
        this.props.setImmediateResponse(true);
    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {

        if (nextProps.spinResult != this.props.spinResult && nextProps.spinResult && nextProps.spinResult.data.response.errorcode) {
            if (nextProps.spinResult.data.response.errorcode == -500) {

            }
            return false
        }
        if (nextProps.initResult != this.props.initResult && nextProps.initResult && nextProps.initResult.data.response.errorcode) {
            if (nextProps.initResult.data.response.errorcode == -500) {

            }
            return false
        }
        if (nextProps.immediateResponseReceived && nextProps.immediateResponseReceived != this.props.immediateResponseReceived) {
            if (this.timeForDropDone) {
                this.setSpinDataForDrop();
            }
        }
        if (nextProps.blastStart && nextProps.blastStart != this.props.blastStart) {

            let timer = TIMER.TimerManager.createTimer(2000);
            timer.on('end', (e: any) => {
                e.remove();
                this.timeForDropDone = true;
                // this.props.setImmediateResponse(true);

                if (this.spinResultReceived) {


                    this.setSpinDataForDrop();
                }
                //this.props.setImmediateResponse(true);

            });
            timer.start();

        }
        if (nextProps.showIntroductionPage && nextProps.showIntroductionPage != this.props.showIntroductionPage) {

            if (this.initResult.state.freespinsRemaining) {
                let timer = TIMER.TimerManager.createTimer(500);
                timer.on('end', () => {
                    this.props.nextAutoplay();
                });
                timer.start();
            }

            return false;
        }
        if (!nextProps.showIntroductionPage && nextProps.showIntroductionPage != this.props.showIntroductionPage) {

            let lockedReelData: any = this.initResult.state.reelHeights;
            if (this.initResult.state.freespinsRemaining) {
                this.props.setApplicationToBaseGameState(false);
                this.props.startFreegame();
                let timer = TIMER.TimerManager.createTimer(500);

                timer.on('end', () => {
                    this.props.nextFreegame();
                });
                timer.start();
            } else {
                if (this.lineWins.length != 0) {

                    this.props.setAllButtonDisable();
                    this.props.setblastStarted();
                }
            }

            return false;
        }
        if (nextProps.isRequestSent && nextProps.isRequestSent != this.props.isRequestSent

        ) {
            this.parseBalanceData(nextProps.balanceInGame - nextProps.betList[nextProps.selectedCoin]);
            this.props.setApplicationBroken(false);
            this.props.setWinDropList([]);

            return false;
        }
        if (nextProps.hasCapped != this.props.hasCapped) {
            return false;
        }
        if (nextProps.basegamestate != this.props.basegamestate) {
            this.winAmountDisplay = 0;
            if (this.props.initResult == undefined) {
                //this.totalWinAmountFG = 0;
                // if (localStorage.getItem("buyInFeature_local")) {
                //     this.freeSpinCounter = 0;
                //     this.totalWinAmountFG = 0;
                //     this.props.setFGCreditWinAmount(this.totalWinAmountFG)
                // }

                if (constant.configGame.buyInFeature_local) {
                    this.freeSpinCounter = 0;

                    this.totalWinAmountFG = 0;
                    this.props.setFGCreditWinAmount(this.totalWinAmountFG)
                }
                //this.props.storeMultiplierValue(1);
            }

            if (!nextProps.basegamestate) {
                this.setReelsTrue = true;
            }
            else {
                this.setReelsTrue = false;
            }
            this.setReelStrip();
            return false;
        }
        if (nextProps.isInitResponseReceived != this.props.isInitResponseReceived) {
            this.winAmountDisplay = 0;
            this.totalWinAmountFG = 0;
            this.initResult = nextProps.initResult.data.response;
            this.parseInitData(nextProps.initResult.data.response);
            return false;
        }
        if (nextProps.isBalanceResponseReceived != this.props.isBalanceResponseReceived) {

            this.parseBalanceData(nextProps.balanceResult);
            return false;
        }
        if (nextProps.resetDropAfterDrop && !nextProps.hasCapped && nextProps.resetDropAfterDrop != this.props.resetDropAfterDrop) {

            // this.props.setWinSymbolCoOrdinate([]);
            // this.props.playSymbolAnim();
            // this.props.blastPositionSet([]);
            // this.props.setGiantWildPositions([]);

            this.props.setImmediateResponse(false);
            // this.props.setWinDropList([]);
            this.props.getApplicationSpinCascadeResponse();
            return false;
        }

        if (nextProps.introductionScreenVisible != this.props.introductionScreenVisible) {
            this.setRadioButtonLocalStorageValue(nextProps.introductionScreenVisible);
            return false;
        }
        if (nextProps.spinResult != this.props.spinResult && nextProps.blastStart) {

            this.spinResultData = nextProps.spinResult.data;
            this.spinResultReceived = true;

            // this.winAmountDisplay = this.winAmountDisplay + nextProps.spinResult.data.response.results.win.total / 20 * nextProps.spinResult.data.response.bet.stake;
            // this.totalWinAmountFG = this.totalWinAmountFG + nextProps.spinResult.data.response.results.win.total / 20 * nextProps.spinResult.data.response.bet.stake;
            
            if (nextProps.spinResult.data.response.state.hasCapped) {
                this.winAmountDisplay = nextProps.spinResult.data.response.state.cap / 10 * nextProps.spinResult.data.response.bet.stake;
                this.totalWinAmountFG = nextProps.spinResult.data.response.state.cap / 10 * nextProps.spinResult.data.response.bet.stake;
                nextProps.spinResult.data.response.state.wonAdditionalSpins = 0;
                nextProps.spinResult.data.response.results.win.total = 0;
                nextProps.spinResult.data.response.state.freespinsRemaining = nextProps.spinResult.data.response.state.totalFSAwarded;
                this.props.setWinSymbolCoOrdinate([]);
                this.props.blastPositionSet([]);
                this.props.setGiantWildPositions([])


            }
          
            // this.parseCascadeData(nextProps.spinResult.data);
            //if (this.timeForDropDone) {

            //  this.props.setImmediateResponse(true);
            // }
            if (this.timeForDropDone) {
                this.setSpinDataForDrop();
            }
            return false;
        }
        if (nextProps.spinResult != this.props.spinResult && !nextProps.blastStart) {

            this.spinResultData = nextProps.spinResult.data;
            this.clearBuyFeatureLocalStorage();

            this.symbolForAnticipationArray = [];
            this.counterScatterCount = 0;
            this.winAmountDisplay = this.winAmountDisplay + nextProps.spinResult.data.response.results.win.total / 10 * nextProps.spinResult.data.response.bet.stake;
            this.totalWinAmountFG = this.totalWinAmountFG + nextProps.spinResult.data.response.results.win.total / 10 * nextProps.spinResult.data.response.bet.stake;

            if (nextProps.spinResult.data.response.state.hasCapped) {
                this.winAmountDisplay = nextProps.spinResult.data.response.state.cap / 10 * nextProps.spinResult.data.response.bet.stake;
                this.totalWinAmountFG = nextProps.spinResult.data.response.state.cap / 10 * nextProps.spinResult.data.response.bet.stake;
                nextProps.spinResult.data.response.state.wonAdditionalSpins = 0;
                nextProps.spinResult.data.response.results.win.total = 0;
                nextProps.spinResult.data.response.state.freespinsRemaining = nextProps.spinResult.data.response.state.totalFSAwarded;
                this.props.setWinSymbolCoOrdinate([]);
                this.props.setGiantWildPositions([])
                this.props.blastPositionSet([]);
            }

            this.props.setWinSymbolCoOrdinate([]);

            this.parseSpinData(nextProps.spinResult.data);

            return false;
        }
        if (nextProps.currentCascadeCount && nextProps.currentCascadeCount != this.props.currentCascadeCount) {

            if (this.lineWins.length == 0) {

                this.winAmountDisplay = 0;


                this.props.blastPositionSet([]);
                this.props.setGiantWildPositions([])
                this.props.flowManagerCalled(true);
            } else {
                let timerValue = 1000;
                let stateData = nextProps.spinResult.data.response.state

                if (stateData.feature) {
                    let featureName = stateData.feature[0].featureName
                    let featureLevel = stateData.feature[0].featureLevel ? stateData.feature[0].featureLevel : ""
                    if (featureName === "ADD_SQUARE_WILD" || featureName === "ADD_WILDS") {


                        if (nextProps.giantWildPositions.length) {

                            nextProps.startGiantWild();
                            timerValue = this.setFeatureStartDelay(featureName, featureLevel);;
                        }
                        if (nextProps.randomWildsPositions.length) {
                            nextProps.startRandomWild();
                            timerValue = this.setFeatureStartDelay(featureName, featureLevel, nextProps.randomWildsPositions);;
                        }
                    }
                }
                let timer = TIMER.TimerManager.createTimer(timerValue);
                timer.on('end', () => {

                    this.props.setblastStarted();
                });
                timer.start();
            }
            return false;

        }

        if (nextProps.increaseBetResult != this.props.increaseBetResult) {
            if (!isMobile) {
                this.props.setApplicationCurrentBetIndex(this.props.betListGameLevel.indexOf(nextProps.increaseBetResult.stake));
            }
            return false;
        }
        return true;
    }

    setFeatureStartDelay(featureName?: any, featureLevel?: any, featurePos?: any): number {
        let startDelay = 1;
        if (featureName === "ADD_WILDS") {
            if (featurePos && featurePos.length > 5) {
                startDelay = 8000;
            } else {
                startDelay = 7300;
            }
        }
        if (featureName === "ADD_SQUARE_WILD") {
            startDelay = (featureLevel === 3) ? 7000 : 6000
        }
        return startDelay;
    }

    setGameModel(Result: any) {
        this.props.setApplicationMaxBet(true);
        this.props.setApplicationDecreaseBet(true);
        this.props.setApplicationIncreaseBet(true);
        this.props.setApplicationShowRTP(Result.config.RTP);
    }

    setFunctions(Result: any) {
        this.props.setApplicationAutoPlayLossLimitEnabled(Result.gameOptions.autoPlayLossLimitEnabled);
        this.props.setApplicationAutoPlayLossLimitMandatory(Result.gameOptions.autoPlayLossLimitMandatory);
        this.props.setApplicationAutoPlaySingleWinLimitEnabled(Result.gameOptions.autoPlaySingleWinLimitEnabled);
        this.props.setApplicationAutoPlaySingleWinLimitMandatory(Result.gameOptions.autoPlaySingleWinLimitMandatory);
        this.props.setApplicationAutoPlayWinLimitEnabled(Result.gameOptions.autoPlayWinLimitEnabled);
        this.props.setApplicationAutoPlayWinLimitMandatory(Result.gameOptions.autoPlayWinLimitMandatory);
        this.props.setApplicationCheatingEnabled(Result.gameOptions.cheatingEnabled);
        this.props.setApplicationCountryCode(Result.gameOptions.countryCode);
        this.props.setApplicationCurrencyCode(Result.gameOptions.currencyCode);
        this.props.setApplicationCurrencyDecimalSeparator(Result.gameOptions.currencyDecimalSeparator);
        this.props.setApplicationCurrencyGroupingSeparator(Result.gameOptions.currencyGroupingSeparator);
        this.props.setApplicationCurrencyIgnoreDecimals(Result.gameOptions.currencyIgnoreDecimals);
        this.props.setApplicationDisableQuickSpin(Result.gameOptions.disableQuickSpin);
        this.props.setApplicationDisableQuickStop(Result.gameOptions.disableQuickStop);
        this.props.setApplicationEnableAutoPlay(Result.gameOptions.enableAutoPlay);
        this.props.setApplicationEnableRiskCard(Result.gameOptions.enableRiskCard);
        this.props.setApplicationHistoryUrl(Result.gameOptions.historyUrl);
        this.props.setApplicationHomeUrl(Result.gameOptions.homeUrl);
        this.props.setApplicationLanguageCode(Result.gameOptions.languageCode);
        this.props.setApplicationRealityCheckTimePassedInSeconds(Result.gameOptions.realityCheckTimePassedInSeconds);
        this.props.setApplicationRealityCheckTimeoutInSeconds(Result.gameOptions.realityCheckTimeoutInSeconds);
        this.props.setApplicationSessionTimeoutInSeconds(Result.gameOptions.sessionTimeoutInSeconds);
        this.props.setApplicationShowCloseButton(Result.gameOptions.showCloseButton);
        this.props.setApplicationShowFullScreenButton(Result.gameOptions.showFullScreenButton);
        this.props.setApplicationShowHelpButton(Result.gameOptions.showHelpButton);
        this.props.setApplicationShowRTP(Result.gameOptions.showRTP);
        this.props.setApplicationShowSettingsControl(Result.gameOptions.showSettingsControl);
        this.props.setApplicationShowTime(Result.gameOptions.showTime);
        this.props.setApplicationShowVolumeControl(Result.gameOptions.showVolumeControl);
    }

    setLandingSymbolSoundData(reelGrid: any) {
        let landingSymbolSoundData: any = []
        reelGrid.forEach((singleReel: any, reelId: any) => {
            singleReel.forEach((symbolId: any, index: any) => {
                if (symbolId === 10 || symbolId === 11) {
                    landingSymbolSoundData.push({ symbolId: symbolId, reel: reelId })
                }
            });
        })
        this.props.setLandingSymbolSoundsArr(landingSymbolSoundData);
    }

    setBlastSymbolSoundData(reelGrid: any) {
        let landingSymbolSoundData: any = []
        reelGrid.forEach((singleReel: any, reelId: any) => {
            singleReel.forEach((symbolId: any, index: any) => {
                if (symbolId === 10 || symbolId === 11) {
                    landingSymbolSoundData.push({ symbolId: symbolId, reel: reelId })
                }
            });
        })
        this.props.setBlastSymbolSoundsArr(landingSymbolSoundData);
    }

    parseCascadeData(Result: any) {

        this.props.setScatterDataBeforeFG([])
        //this.props.setUpdatedWinDisplayDuration(1);
        this.lineWins = [];
        this.blastPositionArray = [];
        let reelData;

        let reelDataArraysCount = [6, 6, 6, 6, 6, 6]
        let stateData = Result.response.state
        let giantWildTriggered = false
        this.props.setGiantWildPositions([])
        this.props.setRandomWildPositions([])
        let giantWildPositions: any = [];
        this.props.setGiantWildRunning(false);
        if (stateData.feature) {
            let featureName = stateData.feature[0].featureName
            let featureLevel = stateData.feature[0].featureLevel

            if (featureName === "ADD_SQUARE_WILD") {
                giantWildTriggered = true;
                let delay = this.setFeatureStartDelay(featureName, featureLevel);
                this.props.setUpdatedWinDisplayDuration(delay);
            }
        }

        // Random Wild parsing start here
        let randomWildTriggered = false
        let randomWildPositions: any = [];

        if (stateData.feature) {
            let featureName = stateData.feature[0].featureName
            let featureLevel = stateData.feature[0].featureLevel
            if (featureName === "ADD_WILDS") {
                randomWildTriggered = true;
                let delay = this.setFeatureStartDelay(featureName, featureLevel);
                this.props.setUpdatedWinDisplayDuration(delay);
            }
        }
        //this.parseGiantWildData(Result)

        let scatterPositions: any = []
        let scatterReelId: any = []
        if (Result.response.results.reels) {
            let reelGrid: any = [];
            let reels = Result.response.results.reels;
            reels.forEach((data: any, reelId: any) => {
                let singleReel: any = [];

                data.forEach((symbolId: any, rowId: any) => {
                    if (giantWildTriggered && symbolId.level) {

                        singleReel.push(symbolId.prevSmbID)
                        giantWildPositions.push({ reel: reelId, row: rowId, transformId: symbolId.smbID })
                    } else if (randomWildTriggered && symbolId.level) {

                        singleReel.push(symbolId.prevSmbID)
                        randomWildPositions.push([reelId, rowId])
                    }
                    else {
                        singleReel.push(symbolId.smbID)
                    }

                    if (symbolId.smbID === 11) {
                        scatterPositions.push([reelId, rowId]);
                        scatterReelId.push(1);
                    }
                });
                reelGrid.push(singleReel)
            });
            if (randomWildTriggered) {

                this.props.featureActive(true);

                this.props.setRandomWildPositions(randomWildPositions)
            }
            if (giantWildTriggered) {

                this.props.setGiantWildPositions(giantWildPositions)
            }
            this.filteredreelData = reelGrid;
            this.setLandingSymbolSoundData(this.filteredreelData);

        }
        if (stateData.feature) {
            let featureName = stateData.feature[0].featureName
            let featureLevel = stateData.feature[0].featureLevel
            if (featureName === "ADD_WILDS") {
                let delay = this.setFeatureStartDelay(featureName, featureLevel, randomWildPositions);
                this.props.setUpdatedWinDisplayDuration(delay);
            }
        }
        this.props.relGridSymbolCountDisplay(reelDataArraysCount);
        if (scatterReelId.length) {
            this.props.setSkullData(scatterReelId);
        }
        //this.props.setScatterPositions(scatterPositions);

        let winningsInCascade = Result.response.results.win.total / 10 * Result.response.bet.stake;

        if (winningsInCascade > 0) {

            if (Result.response.results.reels) {
                let blastSymbolIds: any = []
                let reels = Result.response.results.reels;
                reels.forEach((data: any, reelId: any) => {
                    data.forEach((symbolId: any, rowId: any) => {
                        if (symbolId.explode) {
                            let blastPosition: object = {};

                            blastPosition = {
                                reelId: reelId, rowId: rowId
                            }
                            this.blastPositionArray.push(blastPosition);
                            blastSymbolIds.push(symbolId.smbID);
                        }
                    });
                });
                blastSymbolIds = blastSymbolIds.filter((e: any, i: any, a: any) => a.indexOf(e) === i) // [1, 2, 3, 4]
                this.props.setBlastSymbolSoundsArr(blastSymbolIds);

            }

            this.setWinDropData(Result);
            this.blastPositionArray = this.filterBlastPosition(this.blastPositionArray, giantWildPositions);
            this.props.blastPositionSet(this.blastPositionArray);

            this.lineWins = [
                {
                    id: 0,
                    multiplier: 0,
                    // positions: [{rowId: 4, reelId: 5},{rowId: 4, reelId: 5}],
                    positions: this.blastPositionArray,
                    prize: 0
                }
            ];

        } else {
            this.props.blastPositionSet([]);

            this.lineWins = [];
        }
        let hasfeature: any = [];

        // setHasCapped
        // setCappedAmount
        if (Result.response.state) {
            if (Result.response.state.hasCapped) {
                this.props.setHasCapped(Result.response.state.hasCapped);
            }
            if (Result.response.state.cap) {
                this.props.setCappedAmount(Result.response.state.cap);
            }

        }
        if (Result.response.state && Result.response.state.status === "FREESPINS_TRIGGER") {
            this.totalWinAmountFG = 0
            let countOfFreeGames = Result.response.state.totalFSAwarded - Result.response.state.wonAdditionalMult;
            this.freeSpinCounter = 0;

            if (countOfFreeGames > 0) {
                hasfeature = [1];
                // if (countOfFreeGames - this.storePreviousFreeGameCount > 0) {

                //     let count = Result.response.state.freespinsRemaining;
                //     if (count == 0) {
                //     } else {
                //         this.props.reTriggeredFreegame();

                //     }
                // }

                if (Result.response.state.retrriggerFreeSpin) {
                    this.props.reTriggeredFreegame();
                    this.props.setRetriggerCount(Result.response.state.retrriggerFreeSpin)

                }
                this.storePreviousFreeGameCount = countOfFreeGames;
                this.props.setScatterDataBeforeFG(this.filteredreelData)
            }


            this.props.setTotalWinAmount(this.winAmountDisplay);


        } else if (Result.response.state && Result.response.state.status === "FREESPINS") {

            let countOfFreeGames = Result.response.state.totalFSAwarded - Result.response.state.wonAdditionalMult;
            if (countOfFreeGames > 0) {
                hasfeature = [1];
                // if (countOfFreeGames - this.storePreviousFreeGameCount > 0) {

                //     let count = Result.response.state.freespinsRemaining;
                //     if (count == 0) {
                //     } else {
                //         this.props.reTriggeredFreegame();

                //     }
                // }

                if (Result.response.state.retrriggerFreeSpin) {
                    this.props.reTriggeredFreegame();
                    this.props.setRetriggerCount(Result.response.state.retrriggerFreeSpin)

                }
                this.storePreviousFreeGameCount = countOfFreeGames;
            }
            let count = Result.response.state.freespinsRemaining;

            if (count == 0) {
                this.storePreviousFreeGameCount = 0;
                this.props.activeMultiplier(false);


                let timer = TIMER.TimerManager.createTimer(1000);
                timer.on('end', (e: any) => {
                    e.remove();
                    this.props.setFeatureJustFinished();

                });
                timer.start();
                //
            }

            this.props.setTotalWinAmount(this.winAmountDisplay);
        } else {

            this.storePreviousFreeGameCount = 0;
            this.props.storeMultiplierValue(0);

            hasfeature = [];
        }



        let FWReelData;

        FWReelData = {
            stopReelsAfterWin: this.filteredreelData,
            stopReels: this.filteredreelData,
            wins: this.lineWins,
            balance: Result.response.bet.balance ? Result.response.bet.balance : this.gameBalance,
            winAmount: this.winAmountDisplay,
            feature: hasfeature,
            featureType: hasfeature && (hasfeature.length > 0 ? "FREEGAME" : ""),
            freegameSpinCount: this.freeSpinCounter,
            freegameSpinCountWin: Result.response.state.totalFSAwarded,
            freegameSpinCountRemaining: Result.response.state.freespinsRemaining,

        }

        this.props.storeMultiplierValue(Result.response.state.mult);
        this.props.setTotalCreditWinAmount(this.winAmountDisplay);
        this.props.setFGCreditWinAmount(this.totalWinAmountFG)
        this.props.setApplicationWinAmount(FWReelData.winAmount, FWReelData.wins);
        this.props.setBaseGameSpinSucces(FWReelData);
        this.props.setFreeeGameSpinSucces(FWReelData);
        this.props.setReelSpinCascadeSucces(FWReelData);
        //PARSECASCADE
        if (!this.props.inFreeGame) {
            if (Result.response.bet.balance) {
                this.props.setApplicationBalance(Number(Result.response.bet.balance));

            } else {
                this.props.setApplicationBalance(Number(this.gameBalance + Result.response.state.totalWin / 10 * Result.response.bet.stake));

            }

        }
        this.props.setPreviousBalance(Number(this.gameBalance));
        this.blastPositionArray = [];

        if (Result.response.state.tumble) {
            this.props.setTotalCascadeCount(1);
        } else {
            this.props.setTotalCascadeCount(0);
        }
    }

    parseSpinData(Result: any) {
        this.timeForDropDone = false;
        this.spinResultReceived = false;
        this.winningPosition = [];
        this.counterScatterSymbolForSpin = 0;
        this.scatterCounterForSpin = 0;
        this.setCascadeData(Result, 0);
        if (Result.response.state.tumble) {
            this.props.setTotalCascadeCount(1);
        } else {
            this.props.setTotalCascadeCount(0);
        }
        this.props.setPreviousBalance(Number(this.gameBalance));
    }

    clearBuyFeatureLocalStorage() {
        // localStorage.setItem("buyInFeature_local", "")
        // localStorage.setItem("buyInValue_local", "")
        // localStorage.setItem("selection_local", "-1")

        constant.configGame.buyInFeature_local = false;
        constant.configGame.buyInValue_local = "";
        constant.configGame.selection_local = "-1";
    }

    filterBlastPosition(blastPositions: any, giantWildPositions: any) {
        let updateGiantPos = giantWildPositions.slice();
        if (updateGiantPos.length === 4) {
            updateGiantPos.splice(1, 1)
        } else if (updateGiantPos.length === 9) {
            updateGiantPos.splice(2, 1)
        }

        updateGiantPos.forEach((giantPos: any) => {

            blastPositions.forEach((data: any, index: number) => {
                if (giantPos.reel === data.reelId && giantPos.row === data.rowId) {
                    blastPositions.splice(index, 1)
                }
            });
        });
        return blastPositions;
    }

    setCascadeData(Result: any, currentCascadeCount: number) {

        //this.props.configGame.DISPLAY_ALL_WIN_DURATION = 1;
        //this.props.resetWinDropState()
        this.props.resetWinDropState();
        this.props.setRetriggerCount(0)
        this.props.resetFeatureRetrigger()
        this.props.setScatterDataBeforeFG([])
        this.props.setUpdatedWinDisplayDuration(1);
        this.props.setGiantWildRunning(false);
        this.props.setRandomWildPositions([])
        this.props.setGiantWildPositions([]);
        this.lineWins = [];
        this.blastPositionArray = [];
        let reelData;
        let reelDataArraysCount = [6, 6, 6, 6, 6, 6]
        let stateData = Result.response.state
        let giantWildTriggered = false
        let giantWildPositions: any = [];
        if (stateData.feature) {
            let featureName = stateData.feature[0].featureName
            let featureLevel = stateData.feature[0].featureLevel

            if (featureName === "ADD_SQUARE_WILD") {
                giantWildTriggered = true;
                let delay = this.setFeatureStartDelay(featureName, featureLevel);
                this.props.setUpdatedWinDisplayDuration(delay);
            }
        }

        // Random Wild parsing start here
        let randomWildTriggered = false
        let randomWildPositions: any = [];
        if (stateData.feature) {
            let featureName = stateData.feature[0].featureName
            let featureLevel = stateData.feature[0].featureLevel
            if (featureName === "ADD_WILDS") {
                randomWildTriggered = true;
                let delay = this.setFeatureStartDelay(featureName, featureLevel);
                this.props.setUpdatedWinDisplayDuration(delay);
            }
        }


        let scatterPositions: any = []
        let scatterReelId: any = []
        //this.parseGiantWildData(Result)
        if (Result.response.results.reels) {
            let reelGrid: any = [];
            let reels = Result.response.results.reels;
            reels.forEach((data: any, reelId: any) => {
                let singleReel: any = [];

                data.forEach((symbolId: any, rowId: any) => {
                    if (giantWildTriggered && symbolId.level) {
                        singleReel.push(symbolId.prevSmbID)
                        giantWildPositions.push({ reel: reelId, row: rowId, transformId: symbolId.smbID })
                    } else if (randomWildTriggered && symbolId.level) {

                        singleReel.push(symbolId.prevSmbID)
                        randomWildPositions.push([reelId, rowId])
                    }
                    else {
                        singleReel.push(symbolId.smbID)
                    }
                    if (symbolId.smbID === 11) {
                        scatterPositions.push([reelId, rowId]);
                        scatterReelId.push(1);
                    }
                });
                reelGrid.push(singleReel)
            });
            if (randomWildTriggered) {


                this.props.featureActive(true);


                this.props.setRandomWildPositions(randomWildPositions)
            }
            if (giantWildTriggered) {

                this.props.setGiantWildPositions(giantWildPositions);
            }

            this.filteredreelData = reelGrid;
            this.setLandingSymbolSoundData(this.filteredreelData);

        }
        if (stateData.feature) {
            let featureName = stateData.feature[0].featureName
            let featureLevel = stateData.feature[0].featureLevel
            if (featureName === "ADD_WILDS") {
                let delay = this.setFeatureStartDelay(featureName, featureLevel, randomWildPositions);
                this.props.setUpdatedWinDisplayDuration(delay);
            }
        }
        this.props.relGridSymbolCountDisplay(reelDataArraysCount);
        this.props.setSkullData(scatterReelId);
        //this.props.setScatterPositions(scatterPositions);
        let winningsInCascade = Result.response.results.win.total / 10 * Result.response.bet.stake;
        let onlyAnimate = true;

        if (winningsInCascade > 0) {

            if (Result.response.results.reels) {
                let reelGrid: any = []
                let blastSymbolIds: any = []
                let reels = Result.response.results.reels;
                reels.forEach((data: any, reelId: any) => {
                    data.forEach((symbolId: any, rowId: any) => {
                        if (symbolId.explode) {
                            onlyAnimate = false;
                            let blastPosition: object = {};
                            blastPosition = {
                                reelId: reelId, rowId: rowId
                            }
                            this.blastPositionArray.push(blastPosition);
                            blastSymbolIds.push(symbolId.smbID);
                        }
                        if (symbolId.animate) {
                            let animPosition: object = {};
                            animPosition = {
                                reelId: reelId, rowId: rowId
                            }
                            this.blastPositionArray.push(animPosition);
                            // blastSymbolIds.push(symbolId.smbID);
                        }
                    });
                });

                blastSymbolIds = blastSymbolIds.filter((e: any, i: any, a: any) => a.indexOf(e) === i) // [1, 2, 3, 4]
                this.props.setBlastSymbolSoundsArr(blastSymbolIds);

            }
            this.setWinDropData(Result);
            this.blastPositionArray = this.filterBlastPosition(this.blastPositionArray, giantWildPositions);
            if (!onlyAnimate) {

                this.props.blastPositionSet(this.blastPositionArray);
            }

            this.lineWins = [
                {
                    id: 0,
                    multiplier: 0,
                    positions: this.blastPositionArray,
                    prize: 0
                }
            ];

        } else {
            this.props.blastPositionSet([]);

            this.lineWins = [];
        }
        let hasfeature: any = [];
        if (Result.response.state) {
            if (Result.response.state.hasCapped) {
                this.props.setHasCapped(Result.response.state.hasCapped);
            }
            if (Result.response.state.cap) {
                this.props.setCappedAmount(Result.response.state.cap);
            }

        }
        if (Result.response.state && (Result.response.state.status === "FREESPINS_TRIGGER")) {
            this.totalWinAmountFG = 0;
            this.setReelStrip([], true);
            let countOfFreeGames = Result.response.state.totalFSAwarded - Result.response.state.wonAdditionalMult;
            this.freeSpinCounter = 0;

            if (countOfFreeGames > 0) {
                hasfeature = [1];
                // if (countOfFreeGames - this.storePreviousFreeGameCount > 0) {
                //     let count = Result.response.state.freespinsRemaining;
                //     if (count == 0) {
                //     } else {
                //         this.props.reTriggeredFreegame();

                //     }
                // }
                this.storePreviousFreeGameCount = countOfFreeGames;
                this.props.setScatterDataBeforeFG(this.filteredreelData)
            }

            if (Result.response.state.retrriggerFreeSpin) {
                this.props.reTriggeredFreegame();
                this.props.setRetriggerCount(Result.response.state.retrriggerFreeSpin)

            }

            this.props.setTotalWinAmount(this.winAmountDisplay);


        }
        else if (Result.response.state && Result.response.state.status === "FREESPINS") {
            let countOfFreeGames = Result.response.state.totalFSAwarded - Result.response.state.wonAdditionalMult;

            if (countOfFreeGames > 0) {
                hasfeature = [1];
                // if (countOfFreeGames - this.storePreviousFreeGameCount > 0) {

                //     let count = Result.response.state.freespinsRemaining;
                //     if (count == 0) {
                //     } else {
                //         this.props.reTriggeredFreegame();
                //     }
                // }

                this.storePreviousFreeGameCount = countOfFreeGames;
            }
            if (Result.response.state.retrriggerFreeSpin) {
                this.props.reTriggeredFreegame();
                this.props.setRetriggerCount(Result.response.state.retrriggerFreeSpin)

            }

            let count = Result.response.state.freespinsRemaining;
            if (count == 0) {

                this.storePreviousFreeGameCount = 0;
                this.props.activeMultiplier(false);


                this.props.setFeatureJustFinished();

            }

            this.props.setTotalWinAmount(this.winAmountDisplay);
        } else {

            this.storePreviousFreeGameCount = 0;
            this.props.storeMultiplierValue(0);

            hasfeature = [];
        }

        let freeGameCount = Result.response.state.totalFSAwarded - Result.response.state.freespinsRemaining;
        if (freeGameCount > -1 && this.props.inFreeGame) {
            this.freeSpinCounter++;
        }
        if (Result.response.state && Result.response.state.status === "FREESPINS_TRIGGER") {
            if (Result.response.state.totalFSAwarded == Result.response.state.freespinsRemaining) {
                this.totalWinAmountFG = this.winAmountDisplay;
            }
        }
        let FWReelData;
        if (!Result.response.bet.balance && Result.response.state.freespinsRemaining == 0) {
            this.props.hasBalanceOrEmpty(true);
            this.props.amountAddedAfterFreeGame(Result.response.bet.addBalance);
        }
        FWReelData = {
            stopReelsAfterWin: this.filteredreelData,
            stopReels: this.filteredreelData,
            wins: this.lineWins,
            balance: Result.response.bet.balance ? Result.response.bet.balance : this.gameBalance,
            winAmount: this.winAmountDisplay,
            feature: hasfeature,
            featureType: hasfeature && (hasfeature.length > 0 ? "FREEGAME" : ""),
            freegameSpinCount: this.freeSpinCounter,
            freegameSpinCountWin: Result.response.state.totalFSAwarded,
            freegameSpinCountRemaining: Result.response.state.freespinsRemaining,

        }



        this.props.storeMultiplierValue(Result.response.state.mult);
        this.props.setTotalCreditWinAmount(this.winAmountDisplay)
        this.props.setFGCreditWinAmount(this.totalWinAmountFG)
        this.props.setApplicationWinAmount(FWReelData.winAmount, FWReelData.wins);
        this.props.setBaseGameSpinSucces(FWReelData);
        this.props.setFreeeGameSpinSucces(FWReelData);

        if (currentCascadeCount == 0) {
            this.props.setReelSpinSucces(FWReelData);
            this.props.setWinsSucces(FWReelData);

        } else if (currentCascadeCount > 0) {
            this.props.updateReelData(FWReelData);
            this.props.setWinsSucces(FWReelData);
        }
        //SETCASCADEDATA
        if (!this.props.inFreeGame) {

            if (Result.response.bet.balance) {
                this.props.setApplicationBalance(Number(Result.response.bet.balance));

            } else {
                this.props.setApplicationBalance(Number(this.gameBalance + Result.response.state.totalWin / 10 * Result.response.bet.stake));
            }
        }

        this.blastPositionArray = [];

    }

    setWinDropData(Result: any) {
        let winDropDataArr: any = []
        let winDetails = Result.response.results.win.symbolWin.symbols
        winDetails.forEach((data: any, index: any) => {
            let winDropData: any = {
                multiplier: data.num,
                symbolId: data.smbID,
                wonAmount: data.amt,
            }
            winDropDataArr.push(winDropData);

        });

        this.props.setWinDropList(winDropDataArr)
    }


    setLandingSymbolData(stopReels: any) {

        let symbolBgAnimList: any = [];

        let landingSymbolCount = 0;
        stopReels && stopReels.forEach((singleReelData: any, i: any) => {
            for (let j: any = 0; j < this.props.displayReelGridSymbolCount[i]; j++) {
                if (singleReelData[j] > 65 && singleReelData[j] < 72) {
                    if (i <= landingSymbolCount + 2) {

                        landingSymbolCount++;
                        symbolBgAnimList.push([i, j])
                    }
                }
            }
        });

        // this.props.setLandingPosition([[0, 0], [0, 2]])
        let landingCoordinate: any = []
        symbolBgAnimList.forEach((data: any, index: number) => {
            landingCoordinate.push({
                "reelId": data[0],
                "rowId": data[1],
            })
        })
        this.props.setLandingPosition(landingCoordinate)
    }
    setAnticipationSymbolData(stopReels: any) {
        let anticipationOnReel = [false, false, false, false, false, false]
        let landingSymbolCount = 0;
        let lastScatterReelId = 0;
        stopReels && stopReels.forEach((singleReelData: any, reelId: any) => {
            singleReelData.forEach((symId: any, i: any) => {
                if (symId === 11) {
                    landingSymbolCount++
                    if (landingSymbolCount === 3) {
                        lastScatterReelId = reelId;
                    }
                }
            });

        });
        for (let i: any = 0; i < 6; i++) {
            if (i > lastScatterReelId && landingSymbolCount >= 3 && lastScatterReelId >= 2) {
                anticipationOnReel[i] = true;
            }
        }


    }

    filterSymbolsPosition() {
        // this.symbolForAnticipationArray

    }

    processAnticipation(reels: any) {
        this.symbolForAnticipationArray = [];
        let FS_Symbolcount = 0
        reels.map((data: any, index: number) => {
            data.map((innerData: any, innerIndex: number) => {
                this.anticipationSymbolList.map((symbols: any) => {
                    let object: any = {};
                    if (innerData == symbols) {
                        let alreadyHaveObj = false;
                        for (let k = 0; k < this.symbolForAnticipationArray.length; k++) {
                            if (this.symbolForAnticipationArray[k].rowId == innerIndex + 1 && this.symbolForAnticipationArray[k].reelId == index) {
                                alreadyHaveObj = true;
                            }
                        }
                        FS_Symbolcount++
                        if (!alreadyHaveObj) {
                            object = {
                                rowId: innerIndex + 1,
                                reelId: index,

                            }
                            this.symbolForAnticipationArray.push(object);
                        }
                        //  this.winningPosition.push(object);
                    }

                })


            })

        })

    }

    parseBalanceData(data: any) {

        let actualBalance = data;
        this.gameBalance = actualBalance;
        this.props.setApplicationBalance(actualBalance);
    }

    setBuyFeatureData(Result: any) {
        let buyInfo = Result.config.buyInSetup
        let amountArr: any = [];
        let maxBet: any

        if (Result.config.disableBuyIn == undefined) {
            Result.config.disableBuyIn = true;
        }

        if (buyInfo && buyInfo.options && !Result.config.disableBuyIn) {
            let buyOptions = buyInfo.options[0].price;
            amountArr = buyOptions
            maxBet = buyOptions[1].maxBet

        }
        this.props.setBuyFeatureAmount(amountArr);
        this.props.setBuyFeatureMaxStake(maxBet);
        this.props.setDisableBuyIn(Result.config.disableBuyIn);
        //disableBuyIn
    }
    setPromotionalFreeRoundsData() {
        // this.props.remainingFreeRounds(10);
        // this.props.levelOfBet(10.00);
        // this.props.totalWinAmount(0.00);
        // this.props.setTotalFreeRounds(10);
        // this.props.setTotalValue(100);
        /* debugger */
        /* 
        localStorage.setItem("remaining", "");
        localStorage.setItem("betlevel", "");
        localStorage.setItem("totalwin", "");
        localStorage.setItem("totalrounds","");
        localStorage.setItem("totalValue","");
         */
        let FWReelData = {
            //  stopReels: this.filteredreelData,
            //  reel_data: this.filteredreelData,
            feature: [1],
            featureType: "FREEGAME",
            //  betList: Result.config.betValues,
            //  currentBetIndex: Result.config.betValues.indexOf(Result.bet.stake || Result.config.defaultBetVal),
            freegameSpinCount: 10,
            //  winAmount: this.winAmountDisplay,
            //     scatterWinnings: Result.state && (Result.state.totalWin),
            //    freegameSpinCountWin: Result.state.totalFSAwarded,
            freegameSpinCountRemaining: 10,
        }

        this.props.setFreeeGameSpinSucces(FWReelData);

    }
    parseInitData(Result: any) {

        this.setBuyFeatureData(Result)
        var reelData;
        if (Result.results.reels) {
            let reelGrid: any = []
            let reelData = Result.results.reels;
            reelData.forEach((data: any, reelId: any) => {
                let singleReel: any = [];
                data.forEach((symbolId: any, index: any) => {
                    singleReel.push(symbolId.smbID)
                });
                reelGrid.push(singleReel)
            });
            this.filteredreelData = reelGrid;
            this.props.relGridSymbolCountDisplay([6, 6, 6, 6, 6, 6]);
        }


        //Result.state.totalFSAwarded = 1;
        let balance = Result.bet.balance ? Result.bet.balance : this.gameBalance;
        let coinList = Result.config.betValues
        let temp_maxStake = this.props.maximumStake;

        if (temp_maxStake) {
            let maxIndex = coinList.indexOf(temp_maxStake)
            if (maxIndex > -1) {
                let updatedCoinList: any = [];
                // let maxIndex = coinList.indexOf(temp_maxStake)
                coinList.forEach((data: any, index: any) => {
                    if (index <= maxIndex) {
                        updatedCoinList.push(data)
                    }

                });
                coinList = updatedCoinList
            }
        }
        let coinIndex;
        if (temp_maxStake > 0) {
            coinIndex = Result.bet.stake > temp_maxStake && Result.config.betValues.indexOf(temp_maxStake)
                || Result.config.betValues.indexOf(Result.bet.stake || Result.config.defaultBetVal);
        } else {
            coinIndex = Result.config.betValues.indexOf(Result.bet.stake || Result.config.defaultBetVal);
        }




        let hasfeature: any = [1];
        if (Result.state && Result.state.status === "FREESPINS") {
            this.props.setApplicationBroken(true);
            let countOfFreeGames = Result.state.totalFSAwarded;
            if (countOfFreeGames > 0) {
                hasfeature = [1];
                if (countOfFreeGames - this.storePreviousFreeGameCount > 0) {

                }
                this.storePreviousFreeGameCount = countOfFreeGames;

            }
            let count = Result.state.freespinsRemaining;
            if (count == 0) {
                this.storePreviousFreeGameCount = 0;

            }
            this.props.storeMultiplierValue(Result.state.mult);
            this.props.setTotalWinAmount(Result.state.totalWin / 10);
        } else {

            this.storePreviousFreeGameCount = 0;
            this.props.storeMultiplierValue(0);

            hasfeature = [];
        }

        let freeGameCount = Result.state.totalFSAwarded - Result.state.freespinsRemaining;
        if (freeGameCount === 0) {
            freeGameCount = 1;
        }
        this.freeSpinCounter = Result.state.totalFSAwarded - Result.state.freespinsRemaining;
        if (Result.state.totalFSAwarded > 0) {
            this.props.visibleIntroductionScreen(false);
        }


        let winningsInCascade = Result.results.win.total / 10 * Result.bet.stake;

        if (winningsInCascade > 0) {
            this.props.setApplicationBroken(true);
            if (Result.results.reels) {
                let reelGrid: any = []
                let blastSymbolIds: any = []
                let reels = Result.results.reels;
                reels.forEach((data: any, reelId: any) => {
                    data.forEach((symbolId: any, rowId: any) => {
                        if (symbolId.explode) {
                            let blastPosition: object = {};

                            blastPosition = {
                                reelId: reelId, rowId: rowId
                            }
                            this.blastPositionArray.push(blastPosition);
                            blastSymbolIds.push(symbolId.smbID);
                        }
                    });
                });
                blastSymbolIds = blastSymbolIds.filter((e: any, i: any, a: any) => a.indexOf(e) === i)
                this.props.setBlastSymbolSoundsArr(blastSymbolIds);

            }
            this.props.blastPositionSet(this.blastPositionArray);

            this.lineWins = [
                {
                    id: 0,
                    multiplier: 0,
                    positions: this.blastPositionArray,
                    prize: 0
                }
            ];

            //BaseGameReconsturction
            if ((Result.state && Result.state.status !== "FREESPINS")) {
                // let giantWildTriggered = false
                // let giantWildPositions: any = [];

                // let stateData = Result.state;
                // let reelDataArraysCount = [6, 6, 6, 6, 6, 6];
                // if (stateData.feature) {
                //     let featureName = stateData.feature[0].featureName
                //     let featureLevel = stateData.feature[0].featureLevel

                //     if (featureName === "ADD_SQUARE_WILD") {
                //         giantWildTriggered = true;
                //         let delay = this.setFeatureStartDelay(featureName, featureLevel);
                //         this.props.setUpdatedWinDisplayDuration(delay);
                //     }
                // }

                // // Random Wild parsing start here
                // let randomWildTriggered = false
                // let randomWildPositions: any = [];
                // if (stateData.feature) {
                //     let featureName = stateData.feature[0].featureName
                //     let featureLevel = stateData.feature[0].featureLevel
                //     if (featureName === "ADD_WILDS") {
                //         randomWildTriggered = true;
                //         let delay = this.setFeatureStartDelay(featureName, featureLevel);
                //         this.props.setUpdatedWinDisplayDuration(delay);
                //     }
                // }


                // let scatterPositions: any = []
                // let scatterReelId: any = []
                // //this.parseGiantWildData(Result)

                // if (Result.results.reels) {
                //     let reelGrid: any = [];
                //     let reels = Result.results.reels;
                //     reels.forEach((data: any, reelId: any) => {
                //         let singleReel: any = [];

                //         data.forEach((symbolId: any, rowId: any) => {
                //             if (giantWildTriggered && symbolId.level) {
                //                 singleReel.push(symbolId.prevSmbID)
                //                 giantWildPositions.push({ reel: reelId, row: rowId, transformId: symbolId.smbID })
                //             } else if (randomWildTriggered && symbolId.level) {
                //                 singleReel.push(symbolId.prevSmbID)
                //                 randomWildPositions.push([reelId, rowId])
                //             }
                //             else {
                //                 singleReel.push(symbolId.smbID)
                //             }
                //             if (symbolId.smbID === 11) {
                //                 scatterPositions.push([reelId, rowId]);
                //                 scatterReelId.push(1);
                //             }
                //         });
                //         reelGrid.push(singleReel)
                //     });
                //     if (randomWildTriggered) {
                //         this.props.setRandomWildPositions(randomWildPositions)
                //     }
                //     if (giantWildTriggered) {

                //         this.props.setGiantWildPositions(giantWildPositions);
                //     }

                //     this.filteredreelData = reelGrid;
                //     this.setLandingSymbolSoundData(this.filteredreelData);

                // }
                // if (stateData.feature) {
                //     let featureName = stateData.feature[0].featureName
                //     let featureLevel = stateData.feature[0].featureLevel
                //     if (featureName === "ADD_WILDS") {
                //         let delay = this.setFeatureStartDelay(featureName, featureLevel, randomWildPositions);
                //         this.props.setUpdatedWinDisplayDuration(delay);
                //     }
                // }
                // this.props.relGridSymbolCountDisplay(reelDataArraysCount);
                // this.props.setSkullData(scatterReelId);
                // //this.props.setScatterPositions(scatterPositions);
                // let winningsInCascade = Result.results.win.total / 10 * Result.bet.stake;
                // let onlyAnimate = true;
                if (winningsInCascade > 0) {
                    //this.props.setApplicationBroken(true);
                    this.props.reconstructionBannerShow(true);
                    if (Result.results.reels) {
                        let blastSymbolIds: any = []
                        let reels = Result.results.reels;
                        reels.forEach((data: any, reelId: any) => {
                            data.forEach((symbolId: any, rowId: any) => {
                                if (symbolId.explode) {
                                    let blastPosition: object = {};

                                    blastPosition = {
                                        reelId: reelId, rowId: rowId
                                    }
                                    this.blastPositionArray.push(blastPosition);
                                    blastSymbolIds.push(symbolId.smbID);
                                }
                            });
                        });
                        blastSymbolIds = blastSymbolIds.filter((e: any, i: any, a: any) => a.indexOf(e) === i)
                        this.props.setBlastSymbolSoundsArr(blastSymbolIds);

                    }
                    this.props.blastPositionSet(this.blastPositionArray);

                    this.lineWins = [
                        {
                            id: 0,
                            multiplier: 0,
                            positions: this.blastPositionArray,
                            prize: 0
                        }
                    ];
                }
            }
        } else {
            this.props.blastPositionSet([]);

            this.lineWins = [];
        }


        this.winAmountDisplay = this.winAmountDisplay + Result.state.totalWin / 10 * Result.bet.stake;
        this.totalWinAmountFG = this.winAmountDisplay;
        let FWReelData = {
            stopReels: this.filteredreelData,
            reel_data: this.filteredreelData,
            feature: hasfeature,
            featureType: Result.state && (Result.state.status == "FREESPINS" ? "FREEGAME" : ""),
            betList: Result.config.betValues,
            currentBetIndex: Result.config.betValues.indexOf(Result.bet.stake || Result.config.defaultBetVal),
            freegameSpinCount: this.freeSpinCounter,
            winAmount: this.winAmountDisplay,
            scatterWinnings: Result.state && (Result.state.totalWin),
            freegameSpinCountWin: Result.state.totalFSAwarded,
            freegameSpinCountRemaining: Result.state.freespinsRemaining,
        }

        this.props.setAutoplayList(Result.config.autoPlayValues);
        ///setAutoplayList
        let paytablePayoutsArray = Result.config.paytable;
        this.props.setBetList(FWReelData.betList);
        this.props.storeMultiplierValue(Result.state.mult);
        this.setReelStrip();
        this.props.setReelStripsIndex(0);

        //INIT
        this.props.setApplicationBalance(balance);
        this.props.setReelInitSucces(FWReelData);
        this.props.setBaseGameInitSucces(FWReelData);
        this.props.setFreeeGameSpinSucces(FWReelData);
        this.props.setCoinList(coinList);
        this.props.setSelectedCoin(coinIndex);
        this.props.arrayOfPaytablePayouts(paytablePayoutsArray);

        this.setGameModel(Result);

        if (Result.state && Result.state.status == "FREESPINS") {

            let count = Result.state.freespinsRemaining;
            if (count == 0) {

                this.props.setFeatureJustFinished();
            }
        }
        this.props.setApplicationWinAmount(FWReelData.winAmount);
        this.props.renderingStart(true);

        (window as any).PROMO_ROUNDS_HANDLER._use && this.setPromotionalFreeRoundsData();
    }

    setReelStrip(lockedReel?: any, isFGTriggered?: boolean) {
        let symbols_level_2, symbols_level_3, symbols_level_4, symbols_level_5, symbols_level_6, symbols_level_7;
        if (isFGTriggered) {
            symbols_level_2 = [0, 6, 24, 18, 24, 30, 36, 42, 48, 54, 48, 24];
            symbols_level_3 = [1, 7, 49, 19, 25, 61, 37, 43, 49, 55, 25, 1];
            symbols_level_4 = [2, 8, 14, 56, 26, 32, 38, 44, 50, 14, 62, 20];
            symbols_level_5 = [3, 9, 15, 21, 27, 51, 39, 45, 51, 9, 21, 57];
            symbols_level_6 = [4, 10, 16, 22, 28, 64, 40, 46, 52, 58, 16, 10];
            symbols_level_7 = [5, 11, 17, 23, 29, 35, 41, 47, 53, 29, 29, 35];
        }
        else {
            symbols_level_2 = [0, 6, 12, 18, 24, 30, 36, 42, 48, 54, 42, 6];
            symbols_level_3 = [1, 7, 13, 19, 25, 31, 37, 43, 49, 55, 31, 19];
            symbols_level_4 = [2, 8, 14, 20, 26, 68, 38, 44, 50, 56, 20, 2];
            symbols_level_5 = [3, 9, 15, 63, 27, 33, 39, 45, 51, 57, 9, 39];
            symbols_level_6 = [4, 10, 16, 58, 28, 34, 40, 46, 52, 4, 10, 70];
            symbols_level_7 = [5, 11, 17, 23, 29, 35, 41, 47, 53, 29, 11, 71];
        }
        let collectionOfSymbols: any[];
        collectionOfSymbols = [];
        collectionOfSymbols.push(symbols_level_2, symbols_level_3, symbols_level_4, symbols_level_5, symbols_level_6, symbols_level_7)
        let reelstrip: any[];
        reelstrip = [];
        for (let i = 1; i <= collectionOfSymbols.length; i++) {
            for (let j = 0; j < collectionOfSymbols[i - 1].length; j++) {
                reelstrip.push(collectionOfSymbols[i - 1][j]);
            }
        }



        let collectionOfSymbolsreel1: any[];
        collectionOfSymbolsreel1 = [];
        collectionOfSymbolsreel1.push(symbols_level_2, symbols_level_7)
        let reelstrip_reel1: any[];
        reelstrip_reel1 = [];
        for (let i = 1; i <= collectionOfSymbolsreel1.length; i++) {
            for (let j = 0; j < collectionOfSymbolsreel1[i - 1].length; j++) {
                reelstrip_reel1.push(collectionOfSymbolsreel1[i - 1][j]);
            }
        }


        let finalReelStrip = [reelstrip_reel1, reelstrip, reelstrip, reelstrip, reelstrip, reelstrip_reel1]
        if (lockedReel && lockedReel.length) {

            let collectionOfSymbolsreel1: any[];
            collectionOfSymbolsreel1 = [];
            collectionOfSymbolsreel1.push(symbols_level_7)
            let reelstrip_reel1: any[];
            reelstrip_reel1 = [];
            for (let i = 1; i <= collectionOfSymbolsreel1.length; i++) {
                for (let j = 0; j < collectionOfSymbolsreel1[i - 1].length; j++) {
                    reelstrip_reel1.push(collectionOfSymbolsreel1[i - 1][j]);
                }
            }

            lockedReel.forEach((reelId: any) => {
                finalReelStrip[reelId] = reelstrip_reel1
            });
        }

        this.props.setReelStrips([finalReelStrip]);
    }
    useQuery = () => {
        let search = window.location.search;

        return new URLSearchParams(search);
    }
    canUseStorage() {
        // check that storage is supported and accessible
        const test = 'test-storage';
        try {
            localStorage.setItem(test, test);
            localStorage.removeItem(test);
            return true;
        } catch (e) {
            return false;
        }
    }
    setRadioButtonLocalStorageValue(introductionScreenVisible: any) {
        if (this.canUseStorage()) {
            if (introductionScreenVisible) {
                localStorage.setItem("playerId-postIntro-" + this.useQuery().get("token"), "true");
            } else {
                localStorage.setItem("playerId-postIntro-" + this.useQuery().get("token"), "false");
            }
        } else {
            if (introductionScreenVisible) {
                constant.configGame.playerIdPostIntro = true;
            } else {
                constant.configGame.playerIdPostIntro = false;
            }
        }
    }

    componentDidMount() {
        if (this.canUseStorage()) {
            this.props.visibleIntroductionScreen((localStorage.getItem("playerId-postIntro-" + this.useQuery().get("token")) === "true") ? true : false);
        } else {
            this.props.visibleIntroductionScreen((constant.configGame.playerIdPostIntro) ? true : false);
        }
    }

    render() {
        if (this.canUseStorage()) {
            if (localStorage.getItem("playerId-postIntro-" + this.useQuery().get("token")) === null ||
                localStorage.getItem("playerId-postIntro-" + this.useQuery().get("token")) === undefined) {
                localStorage.setItem("playerId-postIntro-" + this.useQuery().get("token"), "true");
            }
            localStorage.setItem("playerId", this.useQuery().get("token") || "free");
            localStorage.setItem("bridgeUrl", this.useQuery().get("bridgeUrl") || "noURL");
        } else {
            constant.configGame.playerId = this.useQuery().get("token") || "free";
            constant.configGame.bridgeUrl = this.useQuery().get("bridgeUrl") || "noURL";

        }
        return (<div></div>)
    }

}



export default withPixiApp(connect(
    (state: Pick<GJIStore, 'soundActiveScreenState' | 'skullState' | 'basegameState' | 'giantWildState' | 'randomWildsState' | 'betPanelState' | 'wrapperState' | 'gridsState' | 'introductionState' | 'gameactionstate' | 'asyncInitAction' | 'asyncServerAction' | 'asyncGameLevelSeverState' | 'behaviourState' | 'freegameState'>): IStateToProps =>
    ({
        isInitResponseReceived: state.asyncInitAction.isInitResponseReceived,
        isBalanceResponseReceived: state.asyncInitAction.isBalanceResponseReceived,
        initResult: state.asyncInitAction.result,
        balanceResult: state.asyncInitAction.balanceResult,
        balanceInGame: state.basegameState.balance,
        actionResult: state.gameactionstate.result,
        spinResult: state.asyncServerAction.result,
        featureType: state.basegameState.featureType,
        feature: state.basegameState.feature,
        basegamestate: state.basegameState.basegamestate,
        currentCascadeCount: state.gridsState.currentCascadeCount,
        totalCascadeCount: state.gridsState.totalCascadeCount,
        currentBetIndex: state.basegameState.currentBetIndex,
        betList: state.basegameState.betList,
        betIncrease: state.asyncGameLevelSeverState.betIncrease,
        increaseBetResult: state.asyncGameLevelSeverState.result,
        betListGameLevel: state.behaviourState.betList,
        allSpinComplete: state.gridsState.allSpinComplete,
        inFreeGame: state.freegameState.inFreeGame,
        blastStart: state.gridsState.blastStart,
        resetDropAfterDrop: state.gridsState.resetDropAfterDrop,
        introductionScreenVisible: state.introductionState.introductionScreenVisible,
        displayReelGridSymbolCount: state.gridsState.displayReelGridSymbolCount,
        selectedCoin: state.betPanelState.selectedCoin,
        maximumStake: state.wrapperState.maximumStake,
        isRequestSent: state.asyncServerAction.isRequestSent,
        hasCapped: state.behaviourState.hasCapped,
        showIntroductionPage: state.introductionState.showIntroductionPage,
        giantWildPositions: state.giantWildState.giantWildPositions,
        randomWildsPositions: state.randomWildsState.randomWildsPositions,
        skullArr: state.skullState.skullArr,
        immediateResponseReceived: state.gridsState.immediateResponseReceived,


    }),
    (dispatch: Dispatch): IDispatchToProps => ({

        applicationResponsesend: (): any => dispatch(gameActions.getApplicationActionResponse()),
        visibleIntroductionScreen: (value: boolean): any => dispatch(introductionActions.visibleIntroductionScreen(value)),
        setBaseGameInitSucces: (result_reel: any): any => dispatch(baseGameAction.setBaseGameInitSucces(result_reel)),
        setReelInitSucces: (result_reel: any): any => dispatch(gridsActions.setReelInitSucces(result_reel)),
        setReelSpinSucces: (result_reel: any): any => dispatch(gridsActions.setReelSpinSucces(result_reel)),
        setReelSpinCascadeSucces: (result_reel: any): any => dispatch(gridsActions.setReelSpinCascadeSucces(result_reel)),
        updateReelData: (result_reel: any): any => dispatch(gridsActions.updateReelData(result_reel)),
        setReelStrips: (reelStrips: any): any => dispatch(gridsActions.setReelStrips(reelStrips)),
        setReelStripsIndex: (currentReelStripIndex: number): any => dispatch(gridsActions.setReelStripsIndex(currentReelStripIndex)),
        setScatterDataBeforeFG: (scatterData: any): any => dispatch(behaviourAction.setScatterDataBeforeFG(scatterData)),
        setScatterDataAnticipation: (scatterData: any): any => dispatch(behaviourAction.setScatterDataAnticipation(scatterData)),

        setApplicationDecreaseBet: (decreaseBet: boolean): any => dispatch(applicationStateActions.setApplicationDecreaseBet(decreaseBet)),
        setApplicationIncreaseBet: (increaseBet: boolean): any => dispatch(applicationStateActions.setApplicationIncreaseBet(increaseBet)),
        setApplicationMaxBet: (maxBet: boolean): any => dispatch(applicationStateActions.setApplicationMaxBet(maxBet)),
        setApplicationShowPaytable: (showPaytable: boolean): any => dispatch(applicationStateActions.setApplicationShowPaytable(showPaytable)),
        setApplicationSpin: (spin: boolean): any => dispatch(applicationStateActions.setApplicationSpin(spin)),

        setApplicationAutoPlayLossLimitEnabled: (autoPlayLossLimitEnabled: boolean): any => dispatch(applicationStateActions.setApplicationAutoPlayLossLimitEnabled(autoPlayLossLimitEnabled)),
        setApplicationAutoPlayLossLimitMandatory: (autoPlayLossLimitMandatory: boolean): any => dispatch(applicationStateActions.setApplicationAutoPlayLossLimitMandatory(autoPlayLossLimitMandatory)),
        setApplicationAutoPlaySingleWinLimitEnabled: (autoPlaySingleWinLimitEnabled: boolean): any => dispatch(applicationStateActions.setApplicationAutoPlaySingleWinLimitEnabled(autoPlaySingleWinLimitEnabled)),
        setApplicationAutoPlaySingleWinLimitMandatory: (autoPlaySingleWinLimitMandatory: boolean): any => dispatch(applicationStateActions.setApplicationAutoPlaySingleWinLimitMandatory(autoPlaySingleWinLimitMandatory)),
        setApplicationAutoPlayWinLimitEnabled: (autoPlayWinLimitEnabled: boolean): any => dispatch(applicationStateActions.setApplicationAutoPlayWinLimitEnabled(autoPlayWinLimitEnabled)),
        setApplicationAutoPlayWinLimitMandatory: (autoPlayWinLimitMandatory: boolean): any => dispatch(applicationStateActions.setApplicationAutoPlayWinLimitMandatory(autoPlayWinLimitMandatory)),
        setApplicationCheatingEnabled: (cheatingEnabled: boolean): any => dispatch(applicationStateActions.setApplicationCheatingEnabled(cheatingEnabled)),
        setApplicationCountryCode: (countryCode: boolean): any => dispatch(applicationStateActions.setApplicationCountryCode(countryCode)),
        setApplicationCurrencyCode: (currencyCode: boolean): any => dispatch(applicationStateActions.setApplicationCurrencyCode(currencyCode)),
        setApplicationCurrencyDecimalSeparator: (currencyDecimalSeparator: boolean): any => dispatch(applicationStateActions.setApplicationCurrencyDecimalSeparator(currencyDecimalSeparator)),
        setApplicationCurrencyGroupingSeparator: (currencyGroupingSeparator: boolean): any => dispatch(applicationStateActions.setApplicationCurrencyGroupingSeparator(currencyGroupingSeparator)),
        setApplicationCurrencyIgnoreDecimals: (currencyIgnoreDecimals: boolean): any => dispatch(applicationStateActions.setApplicationCurrencyIgnoreDecimals(currencyIgnoreDecimals)),
        setApplicationDisableQuickSpin: (disableQuickSpin: boolean): any => dispatch(applicationStateActions.setApplicationDisableQuickSpin(disableQuickSpin)),
        setApplicationDisableQuickStop: (disableQuickStop: boolean): any => dispatch(applicationStateActions.setApplicationDisableQuickStop(disableQuickStop)),
        setApplicationEnableAutoPlay: (enableAutoPlay: boolean): any => dispatch(applicationStateActions.setApplicationEnableAutoPlay(enableAutoPlay)),
        setApplicationEnableRiskCard: (enableRiskCard: boolean): any => dispatch(applicationStateActions.setApplicationEnableRiskCard(enableRiskCard)),
        setApplicationHistoryUrl: (historyUrl: boolean): any => dispatch(applicationStateActions.setApplicationHistoryUrl(historyUrl)),
        setApplicationHomeUrl: (homeUrl: boolean): any => dispatch(applicationStateActions.setApplicationHomeUrl(homeUrl)),
        setApplicationLanguageCode: (languageCode: boolean): any => dispatch(applicationStateActions.setApplicationLanguageCode(languageCode)),
        setApplicationRealityCheckTimePassedInSeconds: (realityCheckTimePassedInSeconds: boolean): any => dispatch(applicationStateActions.setApplicationRealityCheckTimePassedInSeconds(realityCheckTimePassedInSeconds)),
        setApplicationRealityCheckTimeoutInSeconds: (realityCheckTimeoutInSeconds: boolean): any => dispatch(applicationStateActions.setApplicationRealityCheckTimeoutInSeconds(realityCheckTimeoutInSeconds)),
        setApplicationSessionTimeoutInSeconds: (sessionTimeoutInSeconds: boolean): any => dispatch(applicationStateActions.setApplicationSessionTimeoutInSeconds(sessionTimeoutInSeconds)),
        setApplicationShowCloseButton: (showCloseButton: boolean): any => dispatch(applicationStateActions.setApplicationShowCloseButton(showCloseButton)),
        setApplicationShowFullScreenButton: (showFullScreenButton: boolean): any => dispatch(applicationStateActions.setApplicationShowFullScreenButton(showFullScreenButton)),
        setApplicationShowHelpButton: (showHelpButton: boolean): any => dispatch(applicationStateActions.setApplicationShowHelpButton(showHelpButton)),
        setApplicationShowRTP: (showRTP: boolean): any => dispatch(applicationStateActions.setApplicationShowRTP(showRTP)),
        setApplicationShowSettingsControl: (showSettingsControl: boolean): any => dispatch(applicationStateActions.setApplicationShowSettingsControl(showSettingsControl)),
        setApplicationShowTime: (showTime: boolean): any => dispatch(applicationStateActions.setApplicationShowTime(showTime)),
        setApplicationShowVolumeControl: (showVolumeControl: boolean): any => dispatch(applicationStateActions.setApplicationShowVolumeControl(showVolumeControl)),
        setBaseGameSpinSucces: (result_spin: any): any => dispatch(baseGameAction.setBaseGameSpinSucces(result_spin)),
        setApplicationBalance: (balance: number): any => dispatch(baseGameAction.setApplicationBalance(balance)),

        setApplicationToBaseGameState: (basegamestate: boolean): any => dispatch(basegameActions.setApplicationToBaseGameState(basegamestate)),
        nextFreegame: (): any => dispatch(freegameAction.nextFreegame()),
        startFreegame: (): any => dispatch(freegameAction.startFreegame()),
        setWinsSucces: (result_reel: any): any => dispatch(winActions.setWinsSucces(result_reel)),
        setApplicationWinAmount: (winAmount: number, wins: any): any => dispatch(baseGameAction.setApplicationWinAmount(winAmount, wins)),
        setCoinList: (coinList: any): any => dispatch(betPanelAction.setCoinList(coinList)),
        setSelectedCoin: (selectedCoin: number): any => dispatch(betPanelAction.setSelectedCoin(selectedCoin)),
        arrayOfPaytablePayouts: (paytablePayoutArray: any): any => dispatch(paytableAction.arrayOfPaytablePayouts(paytablePayoutArray)),
        blastPositionSet: (blastPosition: any): any => dispatch(gridsActions.blastPositionSet(blastPosition)),
        relGridSymbolCountDisplay: (displayReelGridSymbolCount: any): any => dispatch(gridsActions.relGridSymbolCountDisplay(displayReelGridSymbolCount)),
        setTotalCascadeCount: (totalCascadeCountAction: number): any => dispatch(gridsActions.setTotalCascadeCount(totalCascadeCountAction)),
        setCurrentCascadeCount: (currentCascadeCountAction: number): any => dispatch(gridsActions.setCurrentCascadeCount(currentCascadeCountAction)),
        renderingStart: (startRendering: any): any => dispatch(asyncActions.renderingStart(startRendering)),

        setApplicationBroken: (gameBroken: any): any => dispatch(asyncActions.setApplicationBroken(gameBroken)),
        setTransitionBalance: (transitionBalance: any): any => dispatch(behaviourAction.setTransitionBalance(transitionBalance)),
        setblastStarted: (): any => dispatch(gridsActions.blastStart()),
        //increaseBet: (betIncrease: any): any => dispatch(gameLevelResponseActions.increaseBet(betIncrease)),
        setPreviousBalance: (previousBalance: any): any => dispatch(behaviourAction.setPreviousBalance(previousBalance)),
        setBetList: (betList: any): any => dispatch(behaviourAction.setBetList(betList)),
        setFreeeGameSpinSucces: (result_spin: any): any => dispatch(freegameAction.setFreeeGameSpinSucces(result_spin)),
        reTriggeredFreegame: (): any => dispatch(freegameAction.reTriggeredFreegame()),
        setTotalCreditWinAmount: (totalCreditWinAmount: any): any => dispatch(behaviourAction.setTotalCreditWinAmount(totalCreditWinAmount)),
        setFGCreditWinAmount: (spinWin: any): any => dispatch(behaviourAction.setFGCreditWinAmount(spinWin)),
        setTotalWinAmount: (totalWinAmount: any): any => dispatch(behaviourAction.setTotalWinAmount(totalWinAmount)),
        setFeatureJustFinished: (): any => dispatch(freegameAction.setFeatureJustFinished()),
        setApplicationCurrentBetIndex: (betIndex: number): any => dispatch(baseGameActions.setApplicationCurrentBetIndex(betIndex)),
        storeMultiplierValue: (storeMultiplierCurrentValue: any): any => dispatch(multiplierActions.storeMultiplierValue(storeMultiplierCurrentValue)),
        activeMultiplier: (multiplierActive: boolean): any => dispatch(multiplierActions.activeMultiplier(multiplierActive)),
        setAllButtonEnable: (exceptBtnList: Array<string>): any => dispatch(buttonActions.setAllButtonEnable(exceptBtnList)),
        setAllButtonDisable: (exceptBtnList: Array<string>): any => dispatch(buttonActions.setAllButtonDisable(exceptBtnList)),
        setLandingPosition: (landingPosition: any): any => dispatch(landingSymbolAction.setLandingPosition(landingPosition)),
        playSymbolAnim: (): any => dispatch(winpresentationAction.playSymbolAnim()),
        setWinSymbolCoOrdinate: (winSymbolCoOrdinate: any): any => dispatch(winpresentationAction.setWinSymbolCoOrdinate(winSymbolCoOrdinate)),
        flowManagerCalled: (callFlowManager: boolean): any => dispatch(flowManagerAction.flowManagerCalled(callFlowManager)),
        getApplicationSpinCascadeResponse: (): any => dispatch(asyncServerActions.getApplicationSpinCascadeResponse()),
        setLockedReelData: (lockedArr: any): any => dispatch(lockedReelActions.setLockedReelData(lockedArr)),
        setRandomWildSymbol: (symbolPos: any): any => dispatch(randomWildAcitons.setRandomWildSymbol(symbolPos)),
        setUpdatedWinDisplayDuration: (duration: any): any => dispatch(randomWildAcitons.setUpdatedWinDisplayDuration(duration)),
        setShowLockedReel: (): any => dispatch(lockedReelActions.setShowLockedReel()),
        resetLockedData: (): any => dispatch(lockedReelActions.resetLockedData()),
        setWildSymbolPosition: (positions: any): any => dispatch(randomWildAcitons.setWildSymbolPosition(positions)),
        setApplicationInitBalanceResponse: (balanceResult: any): any => dispatch(asyncActions.setApplicationInitBalanceResponse(balanceResult)),
        setRetriggerCount: (value: any): any => dispatch(retriggerActions.setRetriggerCount(value)),
        resetFeatureRetrigger: (): any => dispatch(retriggerActions.resetFeatureRetrigger()),
        setAutoplayList: (autoplayList: any): any => dispatch(behaviourAction.setAutoplayList(autoplayList)),
        setLandingSymbolSoundsArr: (symbolSoundArr: any): any => dispatch(behaviourAction.setLandingSymbolSoundsArr(symbolSoundArr)),
        setBlastSymbolSoundsArr: (symbolSoundArr: any): any => dispatch(behaviourAction.setBlastSymbolSoundsArr(symbolSoundArr)),
        setBuyFeatureAmount: (amountArr: any): any => dispatch(behaviourAction.setBuyFeatureAmount(amountArr)),
        setBuyFeatureMaxStake: (maxStake: any): any => dispatch(behaviourAction.setBuyFeatureMaxStake(maxStake)),
        setDisableBuyIn: (disableBuyIn: any): any => dispatch(behaviourAction.setDisableBuyIn(disableBuyIn)),
        setHasCapped: (hasCappedAction: any): any => dispatch(behaviourAction.setHasCapped(hasCappedAction)),
        setCappedAmount: (cappedAmountAction: any): any => dispatch(behaviourAction.setDisableBuyIn(cappedAmountAction)),
        nextAutoplay: (): any => dispatch(baseGameActions.nextAutoplay()),
        setSkullData: (skullArr: any): any => dispatch(skullActions.setSkullData(skullArr)),
        setScatterPositions: (skullArr: any): any => dispatch(skullActions.setScatterPositions(skullArr)),
        setGiantWildPositions: (positions: any): any => dispatch(giantWildActions.setGiantWildPositions(positions)),
        setRandomWildPositions: (positions: any): any => dispatch(gameRandomWildActions.setRandomWildPositions(positions)),
        setImmediateResponse: (immediateResponseReceivedAction: boolean): any => dispatch(gridsActions.setImmediateResponse(immediateResponseReceivedAction)),
        setWinDropList: (dropList: any): any => dispatch(winDropActions.setWinDropList(dropList)),
        resetWinDropState: (): any => dispatch(winDropActions.resetWinDropState()),
        startGiantWild: (): any => dispatch(giantWildActions.startGiantWild()),
        setGiantWildRunning: (wildRunning: any): any => dispatch(giantWildActions.setGiantWildRunning(wildRunning)),
        startRandomWild: (): any => dispatch(gameRandomWildActions.startRandomWild()),
        reconstructionBannerShow: (showBannerForReconstruction: boolean): any => dispatch(baseGameReconstructionActions.reconstructionBannerShow(showBannerForReconstruction)),

        remainingFreeRounds: (freeRoundsRemaining: number): any => dispatch(promotionalFreeRoundActions.remainingFreeRounds(freeRoundsRemaining)),
        levelOfBet: (betLevel: number): any => dispatch(promotionalFreeRoundActions.levelOfBet(betLevel)),
        totalWinAmount: (totalWin: number): any => dispatch(promotionalFreeRoundActions.totalWinAmount(totalWin)),
        setTotalFreeRounds: (totalFreeRounds: number): any => dispatch(promotionalFreeRoundActions.setTotalFreeRounds(totalFreeRounds)),
        setTotalValue: (totalValue: number): any => dispatch(promotionalFreeRoundActions.setTotalValue(totalValue)),
        featureActive: (isFeatureActive: boolean): any => dispatch(gameRandomWildActions.featureActive(isFeatureActive)),
        amountAddedAfterFreeGame: (addOnBalance: any): any => dispatch(behaviourAction.amountAddedAfterFreeGame(addOnBalance)),
        hasBalanceOrEmpty: (hasBalance: boolean): any => dispatch(behaviourAction.hasBalanceOrEmpty(hasBalance)),



    }))(ServerComm)); 